export interface PopupTrack {
  start: number;
  duration: number;
}

const POPUP_MOTION_SCALE = 1.5;
const PROMPT_BOX_RESIZE_DURATION_MS = 240 * POPUP_MOTION_SCALE;
const SURFACE_GROW_DURATION_MS = 320 * POPUP_MOTION_SCALE;
const PROMPT_BOX_TRAVEL_DURATION_MS = 420 * POPUP_MOTION_SCALE;
const HEADER_SLIDE_DURATION_MS = 240 * POPUP_MOTION_SCALE;

export const PROMPT_BOX_RESIZE_TRACK: PopupTrack = {start: 0, duration: PROMPT_BOX_RESIZE_DURATION_MS};
export const SURFACE_GROW_TRACK: PopupTrack = {start: 0, duration: PROMPT_BOX_RESIZE_DURATION_MS + SURFACE_GROW_DURATION_MS};
export const PROMPT_BOX_TRAVEL_TRACK: PopupTrack = {start: 0, duration: PROMPT_BOX_RESIZE_DURATION_MS + PROMPT_BOX_TRAVEL_DURATION_MS};
export const HEADER_SLIDE_TRACK: PopupTrack = {start: SURFACE_GROW_TRACK.duration, duration: HEADER_SLIDE_DURATION_MS};
export const PROMPT_BOX_FRAMED_AT_MS = PROMPT_BOX_RESIZE_DURATION_MS;
export const POPUP_EXPAND_EASING = 'cubic-bezier(0.2, 0, 0, 1)';
export const POPUP_FRAMING_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
export const POPUP_FRAME_RADIUS_PX = 12;
export const POPUP_FRAMING_EXTRA_BOTTOM_PX = 24;
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export interface PromptBoxGeometry {
  top: number;
  marginLeft: string;
  marginRight: string;
}

export interface FrameGeometry {
  height: number;
  promptBox: PromptBoxGeometry | null;
}

export interface SurfaceHeights {
  frameHeight: number;
  collapsedHeight: number;
  framedHeight: number;
}

export interface PromptBoxTravel extends SurfaceHeights {
  collapsed: PromptBoxGeometry;
  expanded: PromptBoxGeometry;
  framingInset: number;
}

export interface PopupGeometry {
  collapsed: FrameGeometry;
  expanded: FrameGeometry;
}
